import {
  Button,
  Buttons,
  Div,
  Modal,
  ModalBackground,
  ModalCard,
  Title,
} from "trunx";

import { ReactNode } from "react";
import { useCookie } from "react-use";

interface DisclaimerProps {
  children: ReactNode;
  outLink: string;
}
const Disclaimer = ({ children, outLink }: DisclaimerProps) => {
  const [accepted, setAccepted] = useCookie("disclaimer");


  const head = (<Div bulma="modal-card-title">Disclaimer</Div>);
  const foot = (
    <Buttons>
      <Button bulma="is-primary" onClick={() => setAccepted("accepted")}>
        Accept
      </Button>
      <Button onClick={() => (window.location.href = outLink)}>
        Home page
      </Button>
    </Buttons>
  );
  return (
    <Modal className="disclaimer" isActive={!accepted}>
      <ModalBackground />
      <ModalCard head={head} foot={foot}>
        <Div bulma="modal-card-body">{children}</Div>
      </ModalCard>
    </Modal>
  );
};

export default Disclaimer;

export const hosted = {
  outLink: "https://www.jefuller.com",
  body: (
    <>
          <Title is={5}>Data Latency</Title>
          The data shown on this JEFMAP is transmitted from multiple agencies
          and is subject to latency. Displayed data may be delayed.
          <hr />
          <Title is={5}>Disclaimer of Warranties</Title>
          This JEFMAP is provided &quot;as is&quot; and &quot;as available&quot; and with all
          faults and defects without warranties of any kind. To the maximum
          extent permitted under applicable law, JE Fuller disclaims all
          warranties, express, implied, or statutory, including warranties of
          merchantability, fitness for a particular purpose, title, and
          non-infringement. The data provided is for informational purposes only
          and should not be relied upon as the sole basis for decisions. Use of
          the application and its data is at your own risk.
          <hr />
          <Title is={5}>Limitation of Liability</Title>
          To the fullest extent permitted by law, JE Fuller and its affiliates
          will not be liable for any indirect, incidental, consequential, or
          special damages arising from your use of, or inability to use,
          this JEFMAP, including loss of data, profits, or business interruption.
          <hr />
          <a href="https://jefullerdata.com/terms" target="_blank" rel="noopener noreferrer">
            View full Terms and Conditions
          </a>
    </>
  ),
};

